/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationData } from './PaginationData';
import {
    PaginationDataFromJSON,
    PaginationDataFromJSONTyped,
    PaginationDataToJSON,
    PaginationDataToJSONTyped,
} from './PaginationData';
import type { Subscription } from './Subscription';
import {
    SubscriptionFromJSON,
    SubscriptionFromJSONTyped,
    SubscriptionToJSON,
    SubscriptionToJSONTyped,
} from './Subscription';

/**
 * Paginated list of subscriptions.
 * @export
 * @interface PaginatedSubscriptions
 */
export interface PaginatedSubscriptions {
    /**
     * List of subscriptions.
     * @type {Array<Subscription>}
     * @memberof PaginatedSubscriptions
     */
    results: Array<Subscription>;
    /**
     * 
     * @type {PaginationData}
     * @memberof PaginatedSubscriptions
     */
    pagination: PaginationData;
}

/**
 * Check if a given object implements the PaginatedSubscriptions interface.
 */
export function instanceOfPaginatedSubscriptions(value: object): value is PaginatedSubscriptions {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PaginatedSubscriptionsFromJSON(json: any): PaginatedSubscriptions {
    return PaginatedSubscriptionsFromJSONTyped(json, false);
}

export function PaginatedSubscriptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSubscriptions {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(SubscriptionFromJSON)),
        'pagination': PaginationDataFromJSON(json['pagination']),
    };
}

export function PaginatedSubscriptionsToJSON(json: any): PaginatedSubscriptions {
    return PaginatedSubscriptionsToJSONTyped(json, false);
}

export function PaginatedSubscriptionsToJSONTyped(value?: PaginatedSubscriptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': ((value['results'] as Array<any>).map(SubscriptionToJSON)),
        'pagination': PaginationDataToJSON(value['pagination']),
    };
}

